const hayatipromaxvape = {
    id: 'hayatipromaxvape',
    publicSiteName: 'Hayati Pro Max Vape',
    branch: process.env.NEXT_PUBLIC_SHOP_BRANCH,
    siteUrl: process.env.NEXT_PUBLIC_SITE_URL,
    googleVerification: process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION,
    gaId: process.env.NEXT_PUBLIC_GA_ID,
    theme: {
        colors: {
            primary: '#008CFF',
            secondary: '#000000',
            color1: '#00D9FF',
            electric_blue: '#008CFF',
            bright_cyan: '#00D9FF',
            royal_blue: '#0057D9',
            deep_blue: '#0036A8',
            navy_blue: '#001D70',
            light_silver: '#E8F2FA',
        },
        fonts: {
            body: 'var(--font-sans)',
            heading: 'var(--font-heading)',
        },
        radius: '4px',
        header: {
            layout: 'minimal',
            dark: true,
            sticky: true,
            showSearch: true,
            showAccount: true,
            showWishlist: true,
            showAnnouncementBar: true,
            transparent: false,
        }
    },
    assets: {
        favicon: '/hayatipromaxvape/favicon.ico',
        logo: '/hayatipromaxvape/logo.png',
    },
    features: {
        rewards: true,
        subscriptions: true,
    },
}

export default hayatipromaxvape